export default __webpack_public_path__ + "static/media/hexagon-on-2--hover.2bed3463.svg";